import React from "react";
import { Modal } from "antd";
import CustomButton from "components/Common/buttons/CustomButton";
import { makeStyles } from "@material-ui/core/styles";
import { customDateFormatWithTime } from "components/Common/formatter";
import { ICONS_MAP } from "pages/price-management/Bundles/bundleDetails/constants";
import classnames from "classnames";

const useStyles = makeStyles({
  modal: {
    "& .ant-modal-content .ant-modal-body": {
      padding: "24px 50px !important",
    },
  },
  titleWithDescription: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    fontWeight: 600,

    borderBottom: "1px solid #0000000D",
    paddingBottom: 20,

    "&>span": {
      fontSize: 13,
      fontWeight: 300,
    },
  },
  container: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
    borderLeft: "none",
    borderRight: "none",
    marginBottom: 30,
    paddingBottom: 30,
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
  },
  list: {},
  item: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  name: {
    fontSize: 14,
    fontWeight: 600,
    display: "flex",
    whiteSpace: "break-spaces",
    alignItems: "center",

    "& span": {
      color: "#00000080",
    },
  },
  date: {
    fontSize: 13,
    fontWeight: 600,
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 5,
    marginRight: 10,
    width: 36,
    height: 36,

    "& img": {
      width: 16,
    },
  },
  noData: {
    padding: 30,
    textAlign: "center",
    fontWeight: 600,
  },
  SetasPrimary: {
    backgroundColor: "#0085FF14",
  },
  RemovePrimary: {
    backgroundColor: "#0000000F",
  },
  "Re-assign": {
    backgroundColor: "#0085FF14",
  },
  "Un-assign": {
    backgroundColor: "#0000000F",
  },
});

const BundleAssignmentHistoryLogModal = ({ logs, data, onClose }) => {
  const classes = useStyles();

  return (
    <Modal
      title={
        <div className={classes.titleWithDescription}>
          Bundle Activity Log
          <span>{`${data.type} - ${data.registrationCategory} - ${data.activationDate} / ${data.deactivationDate}`}</span>
        </div>
      }
      open
      onCancel={onClose}
      closable={false}
      className={classes.modal}
      footer={[]}
    >
      <div className={classes.container}>
        <div className={classes.list}>
          {logs ? (
            logs
              .filter(item => item.bundleAssignmentId === data.id)
              .map(item => (
                <div key={item.bundleAssignmentId} className={classes.item}>
                  <div className={classes.name}>
                    <div className={classnames(classes.iconContainer, classes[item.action.replace(/\s+/g, "")])}>
                      <img src={ICONS_MAP[item.action]} alt={item.action} />
                    </div>
                    {item.action} <span>{` by `}</span> {item.updatedBy}
                  </div>
                  <div className={classes.date}>{customDateFormatWithTime(item.updatedAt)}</div>
                </div>
              ))
          ) : (
            <div className={classes.noData}>No logs found</div>
          )}
        </div>
      </div>
      <div className={classes.actions}>
        <CustomButton onClick={onClose} type="primary" size="small" color="outlined" text="Cancel" />
      </div>
    </Modal>
  );
};

export default BundleAssignmentHistoryLogModal;
